// @flow

import React from 'react';

/**
 * LocaleContext
 * creates the context for locales
 */
export const LocaleContext = React.createContext({ routeLocale: null, userLocale: null });
